"use client"

import { Navigate, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import { toast } from "react-toastify"

const AdminResellerRoute = ({ children }) => {
  const { userInfo } = useSelector((state) => state.auth)
  const location = useLocation()

  useEffect(() => {
    // Show unauthorized access message if user is logged in but not an admin or reseller
    if (userInfo && !["admin", "reseller"].includes(userInfo.user.role)) {
      toast.error("Unauthorized: Admin or Reseller access required")
    }
  }, [userInfo, location.pathname])

  if (!userInfo) {
    // Redirect to login if not logged in
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (!["admin", "reseller"].includes(userInfo.user.role)) {
    // Redirect to dashboard if logged in but not admin or reseller
    return <Navigate to="/dashboard" replace />
  }

  return children
}

export default AdminResellerRoute
